import { Select, SelectField, type SelectFieldProps, type SelectProps } from '@nvision/ui';

import { useClasses } from '../../hooks';
import type { Class, ClassFilters } from '../../models';

export interface ClassFieldProps extends Omit<SelectProps<Class>, 'options'> {
  defaultFilters?: Partial<ClassFilters & { searchParams: { ids: string[] } }>;
  label?: string;
  errorMessage?: SelectFieldProps<Class>['errorMessage'];
  isInvalid?: boolean;
}

export const ClassField: React.FC<ClassFieldProps> = ({ defaultFilters, label, ...otherFieldProps }) => {
  const { data, isLoading, updateFilters } = useClasses(defaultFilters);

  if (label) {
    return (
      <SelectField
        {...otherFieldProps}
        label={label}
        placeholder="Select"
        options={data?.list ?? []}
        onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
        isLoading={isLoading}
      />
    );
  }

  return (
    <Select
      {...otherFieldProps}
      placeholder="Select"
      options={data?.list ?? []}
      onInputChange={(search) => updateFilters({ search: { codeDesc: search } })}
      isLoading={isLoading}
    />
  );
};
